import { render, staticRenderFns } from "./Trademark-details.vue?vue&type=template&id=59c1c485&scoped=true&"
import script from "./Trademark-details.vue?vue&type=script&lang=js&"
export * from "./Trademark-details.vue?vue&type=script&lang=js&"
import style0 from "./Trademark-details.vue?vue&type=style&index=0&id=59c1c485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c1c485",
  null
  
)

export default component.exports